import { createApp } from "vue";
import App from "./App.vue";
import "bootstrap/scss/bootstrap.scss";
import router from "./router";
import "swiper/css/bundle";
import "./assets/css/fontAwesome5Pro.css";
import "bootstrap";
import BootstrapVue3 from "bootstrap-vue-3";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import "./assets/scss/main.scss";

import keycloak from './keycloak';

function renewToken() {
  setInterval(() => {
    if(keycloak?.authenticated){
      // Verifica se o token precisa ser renovado (10 segundos antes de expirar)
      keycloak.updateToken(10).then(refreshed => {
        if (refreshed) {
          console.log('Token renovado!');
        }
      }).catch(error => {
        console.error('Erro ao renovar token:', error);
        keycloak.login();
      });
    }
  }, 60000);  // Checa a cada 60 segundos se o token precisa ser renovado
}


// Inicializa o Keycloak com a configuração 'check-sso', que não obriga o login imediato, mas verifica se o usuário já está autenticado.
keycloak.init({
    onLoad: 'check-sso',     // Não força login, só verifica a sessão existente
    redirectUri: process.env.VUE_APP_KEYCLOAK_REDIRECT_URI || window.location.origin,  // Redirecionamento após login
    pkceMethod: 'S256',      // Usar PKCE para segurança
    checkLoginIframe: false, // 👈 Adicionado para evitar timeout
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
  }).then(authenticated => {
    
    if (authenticated) {
      // 🔹 Limpa a URL antes de montar o Vue Router
      if (window.location.search.includes('code=') || 
          window.location.search.includes('state=') || 
          window.location.search.includes('session_state=')) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    } 
    // Depois de verificar o login (sem forçar), inicializamos a app
    let app = createApp(App);
    // Torna o keycloak acessível globalmente
    app.config.globalProperties.$keycloak = keycloak;
    // Injeta para Composition API
    app.provide('keycloak', keycloak);
    app.use(router);
    app.use(BootstrapVue3);
    app.mount('#app');
    renewToken();
  }).catch(error => {
    console.error('Erro ao iniciar o Keycloak:', error);
  });
  